let envConfig;
if (typeof window === 'undefined') { // If running on Node
  envConfig = process.env;
} else { // Otherwise were on a browser.
  envConfig = window.__envConfig;
}

module.exports = {
  // feature switches
  FEATURE_INTEGRATED_BETSLIP: envConfig.FEATURE_INTEGRATED_BETSLIP,
  FEATURE_PUSH_FAST_RESULTS: envConfig.FEATURE_PUSH_FAST_RESULTS,
  FEATURE_ODDSCHECKER_INTEGRATION: envConfig.FEATURE_ODDSCHECKER_INTEGRATION,
  FEATURE_ODDSCHECKER_INTEGRATION_STAGE2: envConfig.FEATURE_ODDSCHECKER_INTEGRATION_STAGE2,
  FEATURE_ODDSCHECKER_BETSLIP: envConfig.FEATURE_ODDSCHECKER_BETSLIP,

  // config
  PROTECTABLE_FEATURES: envConfig.PROTECTABLE_FEATURES,
  APPLICATION_COLOUR: envConfig.APPLICATION_COLOUR,
  CACHE_HOST: envConfig.CACHE_HOST,
  API_GET_CACHE_BUSTER: envConfig.API_GET_CACHE_BUSTER,
  ITUNES_APP_ID: envConfig.ITUNES_APP_ID,
  FASTRESULTS_APP_ID: envConfig.FASTRESULTS_APP_ID,
  NODE_ENV: envConfig.NODE_ENV,
  SERVICE_APP_HOSTNAME: envConfig.SERVICE_APP_HOSTNAME,
  SERVICE_APP_PORT: envConfig.SERVICE_APP_PORT,
  SERVICE_APP_PROTOCOL: envConfig.SERVICE_APP_PROTOCOL,
  COOKIE_DOMAIN: envConfig.COOKIE_DOMAIN,
  IMAGES_URL: envConfig.IMAGES_URL,
  ROBOTS_TXT: envConfig.ROBOTS_TXT,
  GOOGLE_ANALYTICS_PROPERTY_ID: envConfig.GOOGLE_ANALYTICS_PROPERTY_ID,
  GOOGLE_ANALYTICS_SAMPLING_RATE: envConfig.GOOGLE_ANALYTICS_SAMPLING_RATE,
  GOOGLE_RECAPTCHA_SITE_KEY: envConfig.GOOGLE_RECAPTCHA_SITE_KEY,
  OMNITURE_SERVER: envConfig.OMNITURE_SERVER,
  OMNITURE_SUITE: envConfig.OMNITURE_SUITE,
  SITE_CANONICAL_BASE: envConfig.SITE_CANONICAL_BASE,
  SITEMAP_DAYS_BEHIND: envConfig.SITEMAP_DAYS_BEHIND,
  SITEMAP_DAYS_AHEAD: envConfig.SITEMAP_DAYS_AHEAD,
  SITEMAP_BASKET_ARTICLE_LIMIT: envConfig.SITEMAP_BASKET_ARTICLE_LIMIT,
  GOOGLE_CONSOLE_TAG: envConfig.GOOGLE_CONSOLE_TAG,
  SBG_ACC_ENABLED: envConfig.SBG_ACC_ENABLED,
  SBG_SSO_HOST: envConfig.SBG_SSO_HOST,
  ODDSCHECKER_ENABLED: envConfig.ODDSCHECKER_ENABLED,
  ODDSCHECKER_API_KEY: envConfig.ODDSCHECKER_API_KEY,
  GPT_ENABLED: envConfig.GPT_ENABLED,
  AMAZON_TAM_ENABLED: envConfig.AMAZON_TAM_ENABLED,
  STAGING: envConfig.STAGING,
  API_CROSS_ORIGIN_DISABLED: envConfig.API_CROSS_ORIGIN_DISABLED,
  SERVICE_WORKER_ENABLED: envConfig.SERVICE_WORKER_ENABLED,
  SERVICE_APP_TIMEOUT: envConfig.SERVICE_APP_TIMEOUT,
  SERVICE_SITE_TIMEOUT: envConfig.SERVICE_SITE_TIMEOUT,
  SERVICE_SITE_MAX_CONN: envConfig.SERVICE_SITE_MAX_CONN, // Max agent connection count
  SERVICE_SITE_RESTART_CONN_COUNT: envConfig.SERVICE_SITE_RESTART_CONN_COUNT, // Become unhealthy connection count
  ATR_VIDEO_TIMESTAMP: envConfig.ATR_VIDEO_TIMESTAMP,
  FEATURE_BUCKET_COOKIE_KEY: envConfig.FEATURE_BUCKET_COOKIE_KEY,
  FEATURE_BUCKET_COOKIE_AGE: envConfig.FEATURE_BUCKET_COOKIE_AGE,
  FEATURE_CANARY_CONFIG_URL: envConfig.FEATURE_CANARY_CONFIG_URL,
  FEATURE_CANARY_CONFIG_EXPIRY: envConfig.FEATURE_CANARY_CONFIG_EXPIRY,
  HR_FR_TOPIC: envConfig.HR_FR_TOPIC,
  FEATURE_INSIDER_BENEFITS: envConfig.FEATURE_INSIDER_BENEFITS,
  FOOTBALL_WORLD_CUP_URL: envConfig.FOOTBALL_WORLD_CUP_URL,
  STATIC_ASSET_CACHE_TTL: envConfig.STATIC_ASSET_CACHE_TTL,
  OOYALA_PCODE: envConfig.OOYALA_PCODE,
  OOYALA_BRANDING_ID: envConfig.OOYALA_BRANDING_ID,
  NAV_EVENT_TITLE: envConfig.NAV_EVENT_TITLE,
  NAV_EVENT_URL: envConfig.NAV_EVENT_URL,
  NAV_EVENT_MAIN_INDEX: envConfig.NAV_EVENT_MAIN_INDEX,
  NAV_EVENT_SUB_INDEX: envConfig.NAV_EVENT_SUB_INDEX,
}



// WEBPACK FOOTER //
// ./env.js